import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src="https://i.ibb.co/yYfBMB2/Screenshot-from-2021-10-29-20-55-32.png" alt="" />
        </div>
    );
};

export default NotFound;